module.exports = __webpack_public_path__ + "img/evo.9b10640f.png";